"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DROPS_QUERY_KEY = exports.DROPS_FILTERS_LIST = exports.DROPS_TAB_LIST = exports.DROPS_FILTER_SECTION_MAP = exports.DROPS_TAB_SECTION_MAP = exports.DROPS_STALE_TIME_MS = exports.DROPS_DEFAULT_FILTER = exports.DROPS_DEFAULT_TAB = exports.DROPS_PER_PAGE = exports.DROPS_INITIAL_PAGE = exports.DropsFilter = exports.DropsTabStatus = exports.DROPS_FILTER_TAB_ID = exports.DROPS_STATUS_TAB_ID = void 0;
const keys_1 = require("root/src/shared/constants/keys");
exports.DROPS_STATUS_TAB_ID = 'status';
exports.DROPS_FILTER_TAB_ID = 'filter';
var DropsTabStatus;
(function (DropsTabStatus) {
    DropsTabStatus["Live"] = "live";
    DropsTabStatus["Soon"] = "soon";
    DropsTabStatus["Private"] = "private";
})(DropsTabStatus || (exports.DropsTabStatus = DropsTabStatus = {}));
var DropsFilter;
(function (DropsFilter) {
    DropsFilter["All"] = "all";
    DropsFilter["Community"] = "community";
    DropsFilter["Sponsored"] = "sponsored";
})(DropsFilter || (exports.DropsFilter = DropsFilter = {}));
exports.DROPS_INITIAL_PAGE = 1;
exports.DROPS_PER_PAGE = 10;
exports.DROPS_DEFAULT_TAB = DropsTabStatus.Live;
exports.DROPS_DEFAULT_FILTER = DropsFilter.All;
exports.DROPS_STALE_TIME_MS = 1000 * 10;
exports.DROPS_TAB_SECTION_MAP = {
    [DropsTabStatus.Live]: keys_1.liveEventsKey,
    [DropsTabStatus.Soon]: keys_1.getComingSoonEventsKey,
    [DropsTabStatus.Private]: keys_1.getPrivateLiveEventsKey,
};
exports.DROPS_FILTER_SECTION_MAP = {
    [DropsFilter.All]: undefined,
    [DropsFilter.Community]: keys_1.getCommunityDropEventsKey,
    [DropsFilter.Sponsored]: keys_1.getSponsoredDropEventsKey,
};
exports.DROPS_TAB_LIST = [
    {
        id: exports.DROPS_STATUS_TAB_ID,
        title: 'Live',
        value: DropsTabStatus.Live,
    },
    {
        id: exports.DROPS_STATUS_TAB_ID,
        title: 'Coming soon',
        value: DropsTabStatus.Soon,
    },
    {
        id: exports.DROPS_STATUS_TAB_ID,
        title: 'Private',
        value: DropsTabStatus.Private,
    },
];
exports.DROPS_FILTERS_LIST = [
    {
        id: exports.DROPS_FILTER_TAB_ID,
        title: 'All',
        value: DropsFilter.All,
    },
    {
        id: exports.DROPS_FILTER_TAB_ID,
        title: 'Community',
        value: DropsFilter.Community,
    },
    {
        id: exports.DROPS_FILTER_TAB_ID,
        title: 'Sponsored',
        value: DropsFilter.Sponsored,
    },
];
exports.DROPS_QUERY_KEY = {
    drops: 'drops',
};
